import { omit } from 'lodash';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Navigate, Outlet } from 'react-router-dom';

import { ErrorBoundaryFront } from '@componentsApp/common/index';
import { ROUTES } from '@constantsApp/index';
import { useLocalStorage } from '@hooksApp/index';

const PublicRoute = () => {
  const { userData, recaptcha, setRecaptcha } = useLocalStorage();

  return (
    <>
      {Object.keys(omit(userData, ['domain'])).length > 0 ? (
        <Navigate to={ROUTES.PLATFORM} />
      ) : (
        <ErrorBoundaryFront>
          <GoogleReCaptcha
            onVerify={(token) => {
              if (!recaptcha) setRecaptcha(token);
            }}
          />
          <Outlet />
        </ErrorBoundaryFront>
      )}
    </>
  );
};

export default PublicRoute;
